import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ExecutivePage from './pages/ExecutivePage';
import SecretaryPage from './pages/SecretaryPage';
import AdminPage from './pages/AdminPage';
import { useState } from 'react';

function App() {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem('golf_user'))
  );

  const handleLogin = (loggedInUser) => {
    setUser(loggedInUser);
  };

  const handleLogout = () => {
    localStorage.removeItem('golf_user');
    setUser(null);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            !user ? (
              <LoginPage onLogin={handleLogin} />
            ) : user.role === 'executive' ? (
              <Navigate to="/executive" />
            ) : user.role === 'secretary' ? (
              <Navigate to="/secretary" />
            ) : user.role === 'admin' ? (
              <Navigate to="/admin" />
            ) : (
              <LoginPage onLogin={handleLogin} />
            )
          }
        />
        <Route
          path="/executive"
          element={
            user?.role === 'executive' ? (
              <ExecutivePage onLogout={handleLogout} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/secretary"
          element={
            user?.role === 'secretary' ? (
              <SecretaryPage onLogout={handleLogout} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/admin"
          element={
            user?.role === 'admin' ? (
              <AdminPage onLogout={handleLogout} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;